import { render, staticRenderFns } from "./NewCategory.vue?vue&type=template&id=dc09e572&"
import script from "./NewCategory.vue?vue&type=script&lang=js&"
export * from "./NewCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports